module.exports = __webpack_public_path__ + "static/img/yeswecan0019.874aad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0019.png
// module id = 585
// module chunks = 1